import ro from '../JsonLang/ro.json'
export const lang = { ...ro }